import React from 'react'
import {ListItem, ListItemSecondaryAction, ListItemText, Typography, withStyles} from '@material-ui/core';
import PropTypes from 'prop-types';
import getObjectValue from 'libs/getObjectValue';
import {POSITION_VALUE as demandPositionValue} from 'constants/PositionItems'
import {POSITION_VALUE as pgPositionValue} from 'constants/PurchasingGroupPositionItems'
import Tr from 'translations/Translations';
import IconAddButton from 'components/button/IconAddButton';
import CommissionUserType from "constants/CommissionUserType";
import reduxStore from "redux/store";
import WorkableIconHighlightOffButton from "../../../../button/WorkableIconHighlightOffButton";

const style = theme => ({
    root: {},
    iconButton: {
        padding: theme.spacing(1) / 2,
    },
    email: {
        fontStyle: 'italic',
        fontWeight: theme.typography.fontWeightBold,
        fontSize: '0.75rem'
    }
})

function FullNameItem(
    {
        classes,
        marked = false,
        formikProps,
        addedId,
        item,
        markHistorical
    }) {
    const elementsCount = getObjectValue(addedId, formikProps.values, []).length;
    const editable = getObjectValue('_editable', formikProps.values, true);

    const addPerson = () => {
        const {resources} = reduxStore.getState();
        const pgMode = !!resources.purchasingGroupHeader;

        const nextId = `${addedId}.${elementsCount}`
        formikProps.setFieldValue(nextId, {
            ...item,
            role: pgMode ? (item.userType === CommissionUserType.EXTERNAL_USER ? pgPositionValue.OTHER : pgPositionValue.CHAIRMAN) : demandPositionValue.MEMBER,
            otherRole: ""
        })
    }
    const externalUser = item.userType === CommissionUserType.EXTERNAL_USER;
    const getPrimaryText = () => (<>
        <Typography variant='body2' component='span'>{item.firstName} {item.lastName}</Typography>
        {externalUser && <Typography variant='body2' component='span' className={classes.email}>{' (' + (item.email ? item.email : Tr('email_empty')) + ')'}</Typography>}
    </>)

    const secondaryText = externalUser ? Tr('external') : item.organizationName;

    return (
        <ListItem role="listitem">
            <ListItemText primary={getPrimaryText()} secondary={secondaryText}/>
            <ListItemSecondaryAction>
                {
                    (!!markHistorical && editable && externalUser) &&
                    <WorkableIconHighlightOffButton
                        className={classes.iconButton}
                        tooltip={Tr("archive")}
                        onClick={()=> markHistorical(item.id)}
                        disabled={!editable}
                    />
                }

                <IconAddButton
                    className={classes.iconButton}
                    color='primary'
                    onClick={addPerson}
                    disabled={!editable}
                />
            </ListItemSecondaryAction>
        </ListItem>
    )
}

FullNameItem.propTypes = {
    classes: PropTypes.any,
    name: PropTypes.string,
}

FullNameItem.defaultProps = {}

export default withStyles(style)(FullNameItem);